/**
 * 问卷dem
 * @description 问卷demo
 * @author mll
 * @date 2020-2-20
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '../../../tool'
let { WizContainer } = framework_tool;
import { WizQuestionnair } from '../../../module'

import './index.less'

const tabs = [{ name: '基本题型', type: 'question' }]

class QuestionnairDemo extends WizContainer {

    componentName = 'QuestionnairDemo';

    _renderTabs = (type) => {
        return (
            <div className='questionnair-demo-tabs'>
                {
                    tabs.map((data, index) => {
                        return (
                            <div key={data.type} className='questionnair-demo-active-tab'>
                                {data.name}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    _renderTitle = () => {
        return (
            <div className='questionnair-demo-title'>
                问卷标题
                <div className='questionnair-demo-intro'>问卷说明</div>
            </div>
        )
    }

    _render() {
        return (
            <>
                <WizQuestionnair
                    siderbarClass='questionnair-demo-border'
                    tabs={tabs}
                    renderTitle={this._renderTitle}
                    renderTabs={this._renderTabs}
                />
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(QuestionnairDemo);
